enum EAccessTokenStates {
    VALID = 'VALID',
    NEED_REFRESH = 'NEED_REFRESH',
    FETCH_TOKEN = 'FETCH_TOKEN',
    SESSION_EXPIRED = 'SESSION_EXPIRED',
    OTHER_APPLICATION_CONTEXT = 'OTHER_APPLICATION_CONTEXT',
}

export default EAccessTokenStates
